import React from 'react';

const MealPlanner: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Meal Planner</h1>
      <div className="bg-white rounded-lg shadow-md p-6">
        <p className="text-gray-600">Meal planning feature coming soon!</p>
      </div>
    </div>
  );
};

export default MealPlanner;
